import { createContext } from 'react';

export const OfflineModeContext = createContext({ isOffline: false, syncStatus: 'online' });
